import { CardNetworkRatesTable } from '../card-network-rates-table'

import { ERatePlanTaxCreditBrand } from '@payfac/types';
import type { CardNetworkTablesProps } from "./card-netword-tables.type";
import styles from "./card-newtwork-tables.module.css";

export const CardNetworkTables = ({ data, isLoading, type, isEditing, onChange, onRemoveNetwork, getCompanyPlan, showErrors, taxAggregateVersion, companyNetworks = [] }: CardNetworkTablesProps) => {

    const items = Array.isArray(data) ? data : [];
    const itemIndex = items.findIndex((item) => item?.[type] !== undefined);
    const tabData = itemIndex !== -1 ? items[itemIndex]?.[type] : undefined;

    const sellerNetworks = Object.keys(tabData || {}).filter((key) => key !== "delayForRedeem");

    const networks = Array.from(new Set([...companyNetworks, ...sellerNetworks]))
        .filter((key) => key !== "delayForRedeem")
        .sort((a, b) => (a === "default" ? -1 : b === "default" ? 1 : 0));

    return (
        <div className={styles.container}>

            <div className={styles.tables}>
                <ul className={styles.installments}>
                    {Array.from({ length: 24 }).map((_, i) => (
                        <li key={i} className={styles['installment-item']}>{i + 1}x</li>
                    ))}
                </ul>

                {networks.map((networkKey) => {
                    const isActive = !!tabData?.[networkKey as keyof typeof tabData];
                    const rowData = isActive
                        ? tabData?.[networkKey as keyof typeof tabData]
                        : tabData?.default;

                    return (
                        <div key={networkKey}>
                            <CardNetworkRatesTable
                                data={rowData as any}
                                isLoading={isLoading}
                                isEditing={isEditing}
                                isInactive={!isActive}
                                networkKey={networkKey}
                                onChange={(rateIndex, newValue) => onChange?.(itemIndex, networkKey, rateIndex, newValue)}
                                onRemove={(keyToRemove) => onRemoveNetwork?.(itemIndex, keyToRemove)}
                                newtworkRates={getCompanyPlan?.(networkKey as keyof typeof ERatePlanTaxCreditBrand)?.sellerRates}
                                showErrors={isActive ? showErrors : false}
                                taxAggregateVersion={taxAggregateVersion}
                            />
                        </div>
                    );
                })}
            </div>

        </div>
    );
};